import React from 'react';

const Error = () => {
    return (
        <div className=''>
            <h1 className='text-rose-600 font-bold text-3xl text-center mt-12'>
                
            404! This page is Not found.</h1>
        </div>
    );
};

export default Error;